'use client';

// Affiliate-lenke: rel="sponsored" (Forbrukertilsynet + Googles krav), ny fane,
// og GA4-klikksporing så vi kan se hvilke guider som faktisk sender kjøpere.
// Uten sporingen ville affiliate vært den eneste kanalen vi ikke måler.

import { affiliateMetaFor } from '@/lib/affiliate';

interface Props {
  href: string;
  children: React.ReactNode;
  /** Artikkel-slug, så vi ser hvilken guide klikket kom fra. */
  source?: string;
}

export function AffiliateLink({ href, children, source }: Props) {
  const track = () => {
    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
    const { nettverk, annonsor } = affiliateMetaFor(href);
    w.gtag?.('event', 'affiliate_click', {
      link_url: href.slice(0, 100),
      article: source || 'ukjent',
      network: nettverk,
      partner: annonsor,
    });
  };

  return (
    <a
      href={href}
      onClick={track}
      target="_blank"
      rel="sponsored nofollow noopener noreferrer"
      className="text-stone-700 underline decoration-amber-500 decoration-2 underline-offset-2 hover:text-stone-900 transition-colors"
    >
      {children}
      <span className="text-[10px] text-stone-400 align-super ml-0.5" title="Annonselenke">annonse</span>
    </a>
  );
}
